/* eslint-disable react/prop-types */
import React from 'react'
import SidebarComponent from '../components/SidebarComponent'
import { connect } from 'react-redux'
import { castleActions, userActions } from '../_actions'
function SidebarContainer({ isExpand, updateToolTip, logoutSession }) {
  return (<SidebarComponent
    isExpand={isExpand}
    updateToolTip={updateToolTip}
    logoutSession={logoutSession}
  />)
}
const mapStateToProps = state => {
  return {
    isExpand: state.castle.isExpand
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateToolTip: (isExpand) => dispatch(castleActions.updateToolTip(isExpand)),
    logoutSession: (isLogout) => dispatch(userActions.logoutSession(isLogout))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer)
